<template>
  <div class="ai-visibility-competitor-row" role="row">
    <div class="ai-visibility-competitor-row__name" role="cell">
      <span class="ai-visibility-competitor-row__label">{{ row.brandName || row.domain }}</span>
      <panel-badge
          v-if="row.isTrackedSite"
      >
        You
      </panel-badge>
    </div>
    <score-bar
        role="cell"
        :value="row.visibilityScore"
        :show-value="false"
        :tone="row.isTrackedSite ? 'primary' : 'neutral'"
    />
    <strong role="cell">{{ row.visibilityScore }}</strong>
  </div>
</template>

<script>
import ScoreBar from '../../../ui/display/ScoreBar.vue'
import PanelBadge from '../../../ui/display/PanelBadge.vue'

export default {
  name: 'CompetitorScoreRow',
  components: {
    PanelBadge,
    ScoreBar,
  },
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-competitor-row {
  display: grid;
  grid-template-columns: minmax(120px, 1fr) minmax(150px, 230px) 38px;
  align-items: center;
  gap: 12px;
  border-bottom: 1px dashed var(--v-gray13Color-base);
  padding: 10px 0;
}

.ai-visibility-competitor-row__name {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
  color: var(--v-mainColor-base);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
}

.ai-visibility-competitor-row__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 400;
}

.ai-visibility-competitor-row strong {
  color: var(--v-mainColor-base);
  font-size: 16px;
  text-align: right;
}

@media (max-width: 520px) {
  .ai-visibility-competitor-row {
    grid-template-columns: minmax(0, 1fr) 34px;
  }

  .ai-visibility-competitor-row .ai-visibility-score-bar {
    grid-column: 1 / -1;
    grid-row: 2;
  }
}
</style>
